import { Slot } from 'expo-router'
import { useEffect } from 'react'
import { useAppView } from '~/components/layout/AppViewContext'

export default function PropertyLayout() {
  const { setBackgroundTheme } = useAppView()

  useEffect(() => {
    setBackgroundTheme(1)
  }, [setBackgroundTheme])

  return <Slot />
}
